import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import { mapActions } from 'vuex'
import 'animate.css'
//  reset CSS
import "normalize.css/normalize.css";
import VConsole from "vconsole";
if (window.location.href.indexOf('localhost') > -1 || window.location.href.indexOf('dev.joineast.com') > -1 || window.location.href.indexOf('pierce.joineast.com') > -1 || window.location.href.indexOf('59.61.85.58:13567') > -1 || window.location.href.indexOf('test.joineast.com') > -1 || window.location.href.indexOf('sim.joineast.com') > -1) {
  new VConsole();
}
import ElementUI from "element-ui";
import "element-ui/lib/theme-chalk/index.css";
import "./assets/iconfont/iconfont.css"
import '@/styles/index.scss' // global css
import '@/assets/js/validateConfig'
import { compressFile } from '@/utils'
import "font-awesome/css/font-awesome.min.css"
import msgAlert, { handleForceCloseLoading } from './plugin/msgAlert'
import moment from 'moment'
import privatelyowned from 'privatelyowned'

import { Toast, Notify, Dialog } from 'vant'

Vue.prototype.$toast = Toast
Vue.prototype.$notify = Notify
Vue.prototype.$dialog = Dialog

// moment 时间格式化库
Vue.prototype.$moment = moment
moment.locale('zh-cn') // 这里是进行了汉化 不写这句默认格式是外国的
Vue.prototype.$compressFile = compressFile

import SlideVerify from 'vue-monoplasty-slide-verify'; //vuew支持滑动验证码
import '@/permission' // permission control

// 注册FontAweSome图标自定义组件
Vue.component('JoinIcon', () => import("@/components/JoinIcon/JoinIcon.vue"))

Vue.use(ElementUI);
Vue.use(SlideVerify);
Vue.config.productionTip = false;
Vue.use(msgAlert)
Vue.use(privatelyowned)

new Vue({
  router,
  store,
  render: h => h(App),
  created() {
    this.getSystemType().then(res => {
      this.login()
      this.outLimit()
    })
  },

  methods: {
    ...mapActions([
      'login',
      'outLimit',
      'getSystemType'
    ]),
  },
}).$mount("#app");